<template>
    <div>
        <NotAuthorised v-if="error && error.code === 403" />
        <NotFound v-else-if="error && error.code === 404" />
        <div class="container-nzidoo mt-4" v-else>
            <!-- Product Header Component -->
            <ProductHeader :product="currentProduct" :loading="loader" />
            <BoostPlansMenu :product="currentProduct" />
        </div>
    </div>
</template>

<script>
import AlertService from '@/services/alertService';
import BoostPlansMenu from '@/components/booster/BoostPlansMenu.vue';
import ProductHeader from "@/components/products/ProductHeader.vue";
import NotAuthorised from "@/views/errors/403.vue";
import NotFound from "@/views/errors/404.vue";

export default {
    name: 'BoostPlanManagement',
    components: { BoostPlansMenu, ProductHeader, NotAuthorised, NotFound },
    data() {
        return {
            loader: true,
            currentProduct: null,
            error: null
        };
    },
    async mounted() {
        await this.fetchProduct();
    },
    methods: {
        async fetchProduct() {
            try {
                this.loader=true;
                const productId=this.$route.params.id;
                if (!productId) return;
                const { data }=await this.$axios.get(`product/boost/${productId}`);
                this.currentProduct=data;
            } catch (err) {
                console.error('Error fetching product in BoostPlanManagement:', err);
                this.error = (err.response && err.response.data) || err;
                if (AlertService && AlertService.error) {
                    AlertService.error(this.$t('boost.error'));
                }
            } finally {
                this.loader=false;
            }
        }
    }
};
</script>